class MicrositeNav {

  readonly guideOffsetTop : number;
  stickMenuHeightComputed: boolean;
  stickyMenuHeight: number;
  stickyPosition: number;
  domRoot: HTMLElement;
  indicators: NodeListOf<Element>;
  mobileToggles: HTMLCollectionOf<Element>;

  constructor(domRoot: HTMLElement, params: any) {
    this.stickyPosition = Number(params.stickyPosition);
    this.domRoot = domRoot;
    this.indicators = domRoot.querySelectorAll(".is-nested-microsite-nav");
    this.mobileToggles = document.getElementsByClassName("mobile-header-link");
    this.stickMenuHeightComputed = false;
    this.stickyMenuHeight = 0;
    this.guideOffsetTop = this.domRoot.offsetTop;
    this.init();
  }

  init() {
    document.addEventListener("click", function(e) {
      var sidebarToggled = document.body.classList.contains("sidebar-toggled");
      if (sidebarToggled && e.target.href && e.target.href.indexOf("#navigation") > -1) {
        e.preventDefault();
        window.location.hash = '';
      }
    });

    Array.from(this.indicators).forEach(sideLink => {
      sideLink.addEventListener("click", (e)=> {
        let level = e.target.className.match(/level(\d)/)[1];
        let levelClass = 'level' + level;
        // if (this.domRoot.classList.contains("mobile-reveal") && e.target.classList.contains('level2')) {
        //   return false;
        // } else {
          e.preventDefault();
        // }

        Array.from(this.indicators).forEach(sLink => {
          if (e.target != sLink && !sLink.parentNode.classList.contains('active') && sLink.parentNode.classList.contains(levelClass)) {
            sLink.parentNode.classList.remove("revealed");
          }
        });

        if (!this.domRoot.classList.contains("mobile-reveal")) {
          this.domRoot.parentNode.scrollTop = 0;
        }
        this.domRoot.classList.toggle("mobile-reveal");
        e.target.parentNode.classList.toggle("revealed");        
      });
    });

    Array.from(this.mobileToggles).forEach(mobileToggle => {
      mobileToggle.addEventListener("click", (e)=> {
        this.domRoot.classList.remove("mobile-reveal");
        e.target.parentNode.parentNode.classList.remove("revealed");
      });
    });

    window.addEventListener("scroll", () => {
      this.checkWhichScrolled();
    });
    window.addEventListener("resize", () => {
      this.checkWhichScrolled();
    });
  }

  getStickyMenuHeight(element: Element): number {
    const stickyMenu = element.querySelector('.imkt-navbar__main-section');
    return stickyMenu && stickyMenu.offsetHeight || 0;
  }

  offsetTopFind(el, withHeight = 0) {
    var yPosition = withHeight;
    while (el.offsetParent !== null) {
      yPosition += el.offsetTop;
      el = el.offsetParent;
    }

    // Compute the sticky menu height using the root node
    if (this.stickMenuHeightComputed === false) {
      this.stickyMenuHeight = this.getStickyMenuHeight(el);
      this.stickMenuHeightComputed = true;
    }
    return yPosition;
  }


  checkWhichScrolled() {
    let winTop = window.scrollY;
    let winBot = window.innerHeight;
    let guideStyle = this.domRoot.style;
    let guideHeight = this.domRoot.offsetHeight;

    let parentContainer = this.domRoot.parentNode;
    let sidebarOffset = this.offsetTopFind(parentContainer);
    let parentHeight = this.offsetTopFind(parentContainer.parentNode, parentContainer.parentNode.offsetHeight);
    let bottomPos = winTop - parentHeight + winBot;

    if (winTop >= (sidebarOffset - this.stickyMenuHeight)) {
      guideStyle.position = "fixed";
      guideStyle.maxHeight = "calc(100vh - " + (this.stickyPosition + 50) + "px)";
      guideStyle.width = (this.domRoot.parentNode.offsetWidth - 32) + "px";
      if (winTop > (parentHeight - guideHeight - this.stickyPosition)) {
        guideStyle.bottom = bottomPos + "px";
        guideStyle.top = "auto";
      } else {
        guideStyle.top = (this.stickyMenuHeight + this.guideOffsetTop) + "px";
        guideStyle.bottom = "auto";
      }
    } else {
      guideStyle.position = "static";
      guideStyle.top = "auto";
      guideStyle.bottom = "auto";
      guideStyle.width = "auto";
    }
  }

}

export default MicrositeNav;